import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { ICmsTestimonials } from '@/shared/model/cms-testimonials.model';

const baseApiUrl = 'api/cms-testimonials';

export default class CmsTestimonialsService {
  public find(id: number): Promise<ICmsTestimonials> {
    return new Promise<ICmsTestimonials>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: ICmsTestimonials): Promise<ICmsTestimonials> {
    return new Promise<ICmsTestimonials>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: ICmsTestimonials): Promise<ICmsTestimonials> {
    return new Promise<ICmsTestimonials>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
